// 日订单量级配置
export const ORDER_LEVEL_OPTIONS = [
  { value: '0-100', label: '0-100' },
  { value: '100-200', label: '100-200' },
  { value: '200-300', label: '200-300' },
] as const
